<div *ngIf="typeMessage">
  <span class="badge badge-info">{{ typeMessage | translate }}</span>
</div>
